import styled from "@emotion/styled";

const Button = styled.button`
  border: none;
  color: white;
  width: 100%;
  padding: 1em 0px;
  border-radius: 100px;
  outline: none;
  cursor: pointer;
  background-color: var(--cyan);
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  box-sizing: border-box;
`;

export default Button;
